module.exports = function() {
  return new Worker(__webpack_public_path__ + "278e34129648061a60b8.worker.js");
};